import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons'

import { SitterReserveList } from '~/organisms/reserve/SitterReserveList'
import * as Style from './style.css'

export interface IProps {
  reserves: IReserveSummary[]
  month: number
  year: number
  isActive: boolean
  clickhandler: (yaer: number, month: number) => Promise<void>
}

export const SitterMobileMonthlyReserveListItem = ({
  reserves,
  ...props
}: IProps): JSX.Element => {
  return (
    <div>
      <a
        className={Style.Title}
        onClick={() => void props.clickhandler(props.year, props.month)}
      >
        {props.year}年{props.month.toString().padStart(2, '0')}月
        {props.isActive && (
          <FontAwesomeIcon icon={faChevronUp} className={Style.TitleLinkIcon} />
        )}
        {!props.isActive && (
          <FontAwesomeIcon
            icon={faChevronDown}
            className={Style.TitleLinkIcon}
          />
        )}
      </a>
      {props.isActive && (
        <div className={Style.Content}>
          <SitterReserveList reserves={reserves} />
        </div>
      )}
    </div>
  )
}
